import { IPagination } from 'app/types/common';

export interface IPaymentRecordsState {
  readonly paymentrecordsById?: any;
  readonly paymentrecordIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectPaymentRecordLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddPaymentRecord?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPaymentRecordIds?: string[];
  readonly currentPaymentRecordId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPaymentRecordsSelector extends IPaymentRecordsState {
  readonly currentPaymentRecord?: any;
  readonly currentFormPaymentRecord?: any;
  readonly getPaymentRecordsFilteredByTagInSelectFormat?: any;
  readonly paymentrecordsByIdInSelectFormat?: any;
}

export enum PaymentRecordsActionTypes {
  GET_ALL_PAYMENT_RECORDS_REQUESTED = 'redux-app/payment-records/GET_ALL_PAYMENT_RECORDS_REQUESTED',
  GET_ALL_PAYMENT_RECORDS_PENDING = 'redux-app/payment-records/GET_ALL_PAYMENT_RECORDS_PENDING',
  GET_ALL_PAYMENT_RECORDS_SUCCESS = 'redux-app/payment-records/GET_ALL_PAYMENT_RECORDS_SUCCESS',
  GET_ALL_PAYMENT_RECORDS_FAIL = 'redux-app/payment-records/GET_ALL_PAYMENT_RECORDS_FAIL',
  GET_PAYMENTRECORD_REQUESTED = 'redux-app/payment-records/GET_PAYMENTRECORD_REQUESTED',
  GET_PAYMENTRECORD_PENDING = 'redux-app/payment-records/GET_PAYMENTRECORD_PENDING',
  GET_PAYMENTRECORD_SUCCESS = 'redux-app/payment-records/GET_PAYMENTRECORD_SUCCESS',
  GET_PAYMENTRECORD_FAIL = 'redux-app/payment-records/GET_PAYMENTRECORD_FAIL',
  UPDATE_PAYMENTRECORD_REQUESTED = 'redux-app/payment-records/UPDATE_PAYMENTRECORD_REQUESTED',
  UPDATE_PAYMENTRECORD_PENDING = 'redux-app/payment-records/UPDATE_PAYMENTRECORD_PENDING',
  UPDATE_PAYMENTRECORD_SUCCESS = 'redux-app/payment-records/UPDATE_PAYMENTRECORD_SUCCESS',
  UPDATE_PAYMENTRECORD_FAIL = 'redux-app/payment-records/UPDATE_PAYMENTRECORD_FAIL',
  CREATE_PAYMENTRECORD_REQUESTED = 'redux-app/payment-records/CREATE_PAYMENTRECORD_REQUESTED',
  CREATE_PAYMENTRECORD_PENDING = 'redux-app/payment-records/CREATE_PAYMENTRECORD_PENDING',
  CREATE_PAYMENTRECORD_SUCCESS = 'redux-app/payment-records/CREATE_PAYMENTRECORD_SUCCESS',
  CREATE_PAYMENTRECORD_FAIL = 'redux-app/payment-records/CREATE_PAYMENTRECORD_FAIL',
  DELETE_PAYMENTRECORD_REQUESTED = 'redux-app/payment-records/DELETE_PAYMENTRECORD_REQUESTED',
  DELETE_PAYMENTRECORD_PENDING = 'redux-app/payment-records/DELETE_PAYMENTRECORD_PENDING',
  DELETE_PAYMENTRECORD_SUCCESS = 'redux-app/payment-records/DELETE_PAYMENTRECORD_SUCCESS',
  DELETE_PAYMENTRECORD_FAIL = 'redux-app/payment-records/DELETE_PAYMENTRECORD_FAIL',
  SELECT_PAYMENTRECORD_REQUESTED = 'redux-app/payment-records/SELECT_PAYMENTRECORD_REQUESTED',
}

export default null;
